var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaFeaturedIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 71",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.683 5.292c16.131 21.18-7.81 45.121-28.99 28.99-16.13-21.18 7.81-45.121 28.99-28.99",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.105 12.778H29.878a3.209 3.209 0 00-3.208 3.209v21.391a3.209 3.209 0 003.208 3.209h34.227a3.209 3.209 0 003.208-3.209V15.987a3.209 3.209 0 00-3.208-3.209",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.67 24.543v-8.556a3.209 3.209 0 013.208-3.209h34.227a3.209 3.209 0 013.208 3.209v21.391a3.209 3.209 0 01-3.208 3.209H29.878a3.209 3.209 0 01-3.208-3.209v-9.626",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.105 15.987l-13.35 11.442a5.778 5.778 0 01-7.527 0l-13.35-11.442M52.339 25.613l11.766 11.765M41.644 25.613l-5.348 5.348",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.435 34.17H4.209A3.209 3.209 0 001 37.377V58.77a3.209 3.209 0 003.209 3.208h34.226a3.209 3.209 0 003.209-3.208V37.378a3.209 3.209 0 00-3.21-3.209",
    fill: "#E74A10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.644 48.074V37.378a3.209 3.209 0 00-3.21-3.209H4.21A3.209 3.209 0 001 37.38v21.39a3.209 3.209 0 003.209 3.21h34.226a3.209 3.209 0 003.209-3.21v-6.417",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.365 37.378L25.085 48.82a5.778 5.778 0 01-7.527 0L4.208 37.378M26.67 47.004L38.435 58.77M15.439 47.539L4.209 58.77M30.948 24.543H18.113M22.391 12.778H10.626M37.365 49.143H50.2M45.922 61.978h11.765",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E8E9EA",
    strokeWidth: 2,
    d: "M21.322 69.465H51.27M50.2 5.291H20.252"
  }))));
}
export default SvgEaFeaturedIcon3;